export const lanList = ['zh', 'en', 'jp'];

interface LanguageInterface {
	[key: string]: string;
}
export const LANGUAGE_NAME_MAP: LanguageInterface = {
	zh: '繁體中文',
	en: 'English',
	jp: '日本語',
};
